// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__YUOw5","header":"MessagesList_header__2ercj","chat":"MessagesList_chat__2ppuU"};